import { FinessDto, ICategory, Zone } from '@/state/reducers/ForfaitReducer'
import { axios, getConfigs, IRequestConfig } from './api'

export class FTService {
  static getModality(): Promise<ICategory[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        '/ft/ForfaitsTechnique/Modalite',
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static getCategory(): Promise<ICategory[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        '/ft/ForfaitsTechnique/Categorie',
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static getZoneGeographique(): Promise<Zone[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        '/ft/ForfaitsTechnique/ZoneGeographique/ZonGeographique',
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static getFiness(): Promise<FinessDto[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        '/fft/finess',
        {},
      )
      axios(configs, resolve, reject)
    })
  }
}
